import styled from 'styled-components';

import { TotemPopup } from 'components/TotemPopup';
import { ReplaceProductInTemplates } from '../../Products/ProductDetails/components/ReplaceProductInTemplates';

export function ReplaceMicrostoreColumnTemplateProductsPopup({
    isOpen,
    setIsOpen,
}: {
    isOpen: boolean;
    setIsOpen: (arg: boolean) => void;
}) {
    const closeModal = () => {
        setIsOpen(false);
    };

    return (
        <TotemPopup
            title="Remplacer les produits dans tous les templates"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            contentOverflow="visible"
        >
            <Content>
                <Description>
                    Cette action remplacera l'élément sélectionné dans{' '}
                    <strong>tous les templates de colonne microstore</strong>.
                </Description>

                <WarningText>
                    ⚠️ Attention : vérifiez que la dimension du produit / gamme de remplacement correspond à celle du
                    produit retiré (poids, volume, portions, compatibilité colonne).
                </WarningText>
                <ReplaceProductInTemplates onSuccess={closeModal} />
            </Content>
        </TotemPopup>
    );
}

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

const Description = styled.div`
    color: ${({ theme }) => theme.textColor};
    line-height: 1.4;
`;

const WarningText = styled.div`
    color: ${({ theme }) => theme.warningColor};
    font-weight: bold;
    text-align: center;
`;
